import { render, staticRenderFns } from "./SeccionModulos.vue?vue&type=template&id=54d7a2c3&scoped=true"
import script from "./SeccionModulos.vue?vue&type=script&lang=js"
export * from "./SeccionModulos.vue?vue&type=script&lang=js"
import style0 from "./SeccionModulos.vue?vue&type=style&index=0&id=54d7a2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7a2c3",
  null
  
)

export default component.exports